import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";

import { Box } from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { useFormik, useFormikContext, Field } from "formik";

export default class Dynamic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      directors_array: [this.props.values.directors_array],
    };
  }

  appendInput_director() {
    const newInput = `director-${this.state.directors_array.length}`;
    this.props.setFieldValue("directors_array", [
      ...this.props.values.directors_array,
      newInput,
    ]);
    /**
     * Field value dynamique pour composant controllé dynamique
     */
    const index = this.props.values.gpxTrace.length;
    this.props.setFieldValue("gpxTrace", [
      ...this.props.values.gpxTrace,
      { name: `gpxTrace-${index}`, file: [], traceName: "" },
    ]);

    /**
     * Append nouvelle row
     */
    this.setState((prevState) => ({
      directors_array: prevState.directors_array.concat([newInput]),
    }));
  }

  removeInput_director(index) {
    if (index > 0) {
      const newInput = this.state.directors_array;
      newInput.splice(index, 1);
      console.log(newInput);
      console.log(index);
      this.setState({ directors_array: newInput });
      this.props.values.gpxTrace.pop();
    }
  }

  render() {
    return (
      <div>
        {this.state.directors_array.map((input, index) => (
          <div key={index}>
            <Box mb={1} className="DynamicTextField">
              <Grid container spacing={2}>
                <Grid item md={6} className="UploadGpxButton">
                  <Field
                    key={index}
                    name={this.props.values.gpxTrace[index].name}
                  >
                    {({ field, form, meta }) => (
                      <DropzoneArea
                        filesLimit={1}
                        noKeyboard={false}
                        acceptedFiles={[".gpx"]}
                        dropzoneClass="dropzoneArea"
                        dropzoneText=""
                        {...field}
                        onChange={(e) => {
                          if (e[0]) {
                            this.props.values.gpxTrace[index].file[index] = e;
                          }
                        }}
                        initialFiles={
                          this.props.values.gpxTrace[index].file[index]
                        }
                        useChipsForPreview={true}
                        showAlerts={[]}
                      />
                    )}
                  </Field>
                </Grid>
                <Grid item md={6} className="UploadGpxButton">
                  <Field key={index} name={this.props.values.gpxTrace[index]}>
                    {({ field, form, meta }) => (
                      <TextField
                        label="Le nom de votre trace"
                        {...field}
                        onChange={(e) => {
                          this.props.values.gpxTrace[index].traceName =
                            e.target.value;
                        }}
                        defaultValue={
                          this.props.values.gpxTrace[index].traceName
                        }
                        InputProps={{
                          endAdornment: [
                            index > 0 ? (
                              <RemoveCircleIcon
                                fontSize="default"
                                onClick={() => this.removeInput_director(index)}
                                color="secondary"
                              />
                            ) : (
                              []
                            ),
                            <AddCircleIcon
                              fontSize="default"
                              onClick={() => this.appendInput_director()}
                              color="primary"
                            />,
                          ],
                        }}
                      />
                    )}
                  </Field>
                </Grid>
              </Grid>
            </Box>
          </div>
        ))}
      </div>
    );
  }
}
